/**
 * Defy Sports AI Chat Widget
 * Standalone vanilla JS widget — no dependencies required.
 * Calls the deployed defy-concept tRPC API for AI responses.
 */
(function () {
  "use strict";

  const API_URL = "https://defysport-yswegefu.manus.space/api/trpc/chat.message";

  // ── State ──────────────────────────────────────────────────────────────────
  let isOpen = false;
  let isTyping = false;
  let messages = [
    {
      role: "assistant",
      content:
        "Hi! I'm **Defy**, your sports kit assistant 👋\n\nI can help you find the right teamwear, answer questions about personalisation, club shops, delivery, or anything else Defy Sports related.\n\nWhat can I help you with today?",
    },
  ];

  // ── Styles ─────────────────────────────────────────────────────────────────
  const style = document.createElement("style");
  style.textContent = `
    #defy-chat-root * {
      box-sizing: border-box;
      font-family: 'Barlow', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      margin: 0;
      padding: 0;
    }
    #defy-chat-root {
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 99999;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 12px;
    }
    #defy-chat-bubble {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: #2da137;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 20px rgba(45, 161, 55, 0.4);
      transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.2s;
      flex-shrink: 0;
    }
    #defy-chat-bubble:hover {
      transform: scale(1.08);
      box-shadow: 0 6px 28px rgba(45, 161, 55, 0.55);
    }
    #defy-chat-bubble:active {
      transform: scale(0.96);
    }
    #defy-chat-bubble svg {
      width: 26px;
      height: 26px;
      fill: #fff;
    }
    #defy-chat-window {
      width: 360px;
      max-height: 520px;
      background: #111;
      border-radius: 12px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.5);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      border: 1px solid rgba(255,255,255,0.08);
      transform-origin: bottom right;
      animation: defy-chat-open 0.22s cubic-bezier(0.23, 1, 0.32, 1) forwards;
    }
    @keyframes defy-chat-open {
      from { opacity: 0; transform: scale(0.92) translateY(8px); }
      to   { opacity: 1; transform: scale(1) translateY(0); }
    }
    #defy-chat-header {
      background: #1a1a1a;
      border-bottom: 1px solid rgba(255,255,255,0.08);
      padding: 14px 16px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    #defy-chat-header-avatar {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      background: #2da137;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    #defy-chat-header-avatar svg {
      width: 18px;
      height: 18px;
      fill: #fff;
    }
    #defy-chat-header-info {
      flex: 1;
    }
    #defy-chat-header-name {
      font-size: 14px;
      font-weight: 700;
      color: #fff;
      letter-spacing: 0.02em;
    }
    #defy-chat-header-status {
      font-size: 11px;
      color: #2da137;
      display: flex;
      align-items: center;
      gap: 4px;
      margin-top: 1px;
    }
    #defy-chat-header-status::before {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #2da137;
      display: inline-block;
    }
    #defy-chat-close {
      background: none;
      border: none;
      cursor: pointer;
      color: rgba(255,255,255,0.4);
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: color 0.15s, background 0.15s;
    }
    #defy-chat-close:hover {
      color: #fff;
      background: rgba(255,255,255,0.08);
    }
    #defy-chat-close svg {
      width: 16px;
      height: 16px;
    }
    #defy-chat-messages {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      scrollbar-width: thin;
      scrollbar-color: rgba(255,255,255,0.1) transparent;
    }
    #defy-chat-messages::-webkit-scrollbar {
      width: 4px;
    }
    #defy-chat-messages::-webkit-scrollbar-thumb {
      background: rgba(255,255,255,0.1);
      border-radius: 2px;
    }
    .defy-msg {
      display: flex;
      flex-direction: column;
      max-width: 88%;
    }
    .defy-msg.user {
      align-self: flex-end;
      align-items: flex-end;
    }
    .defy-msg.assistant {
      align-self: flex-start;
      align-items: flex-start;
    }
    .defy-msg-bubble {
      padding: 10px 14px;
      border-radius: 12px;
      font-size: 13.5px;
      line-height: 1.55;
    }
    .defy-msg.user .defy-msg-bubble {
      background: #2da137;
      color: #fff;
      border-bottom-right-radius: 3px;
    }
    .defy-msg.assistant .defy-msg-bubble {
      background: #1e1e1e;
      color: rgba(255,255,255,0.9);
      border-bottom-left-radius: 3px;
      border: 1px solid rgba(255,255,255,0.06);
    }
    .defy-msg-bubble strong {
      font-weight: 700;
      color: #fff;
    }
    .defy-msg-bubble a {
      color: #2da137;
      text-decoration: underline;
    }
    .defy-msg-bubble a:hover {
      color: #3dc44a;
    }
    .defy-msg-bubble ul, .defy-msg-bubble ol {
      padding-left: 18px;
      margin: 6px 0;
    }
    .defy-msg-bubble li {
      margin: 3px 0;
    }
    .defy-msg-bubble p {
      margin: 4px 0;
    }
    .defy-msg-bubble h1, .defy-msg-bubble h2, .defy-msg-bubble h3 {
      font-size: 14px;
      font-weight: 700;
      margin: 6px 0 3px;
    }
    .defy-msg-bubble code {
      background: rgba(255,255,255,0.08);
      padding: 1px 5px;
      border-radius: 3px;
      font-size: 12px;
    }
    .defy-typing {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 10px 14px;
      background: #1e1e1e;
      border-radius: 12px;
      border-bottom-left-radius: 3px;
      border: 1px solid rgba(255,255,255,0.06);
      width: fit-content;
    }
    .defy-typing-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: rgba(255,255,255,0.4);
      animation: defy-typing-bounce 1.2s infinite;
    }
    .defy-typing-dot:nth-child(2) { animation-delay: 0.2s; }
    .defy-typing-dot:nth-child(3) { animation-delay: 0.4s; }
    @keyframes defy-typing-bounce {
      0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
      30% { transform: translateY(-4px); opacity: 1; }
    }
    #defy-chat-suggestions {
      padding: 0 16px 12px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    }
    .defy-suggestion {
      background: rgba(255,255,255,0.06);
      border: 1px solid rgba(255,255,255,0.1);
      color: rgba(255,255,255,0.75);
      font-size: 12px;
      padding: 5px 10px;
      border-radius: 20px;
      cursor: pointer;
      transition: background 0.15s, border-color 0.15s, color 0.15s;
      white-space: nowrap;
    }
    .defy-suggestion:hover {
      background: rgba(45, 161, 55, 0.15);
      border-color: rgba(45, 161, 55, 0.4);
      color: #fff;
    }
    #defy-chat-input-row {
      border-top: 1px solid rgba(255,255,255,0.08);
      padding: 12px;
      display: flex;
      gap: 8px;
      align-items: center;
      background: #1a1a1a;
    }
    #defy-chat-input {
      flex: 1;
      background: rgba(255,255,255,0.07);
      border: 1px solid rgba(255,255,255,0.1);
      border-radius: 8px;
      padding: 9px 12px;
      color: #fff;
      font-size: 13.5px;
      outline: none;
      transition: border-color 0.15s;
    }
    #defy-chat-input::placeholder {
      color: rgba(255,255,255,0.3);
    }
    #defy-chat-input:focus {
      border-color: rgba(45, 161, 55, 0.5);
    }
    #defy-chat-send {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      background: #2da137;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: background 0.15s, transform 0.1s;
    }
    #defy-chat-send:hover {
      background: #1e7228;
    }
    #defy-chat-send:active {
      transform: scale(0.93);
    }
    #defy-chat-send:disabled {
      background: rgba(45, 161, 55, 0.35);
      cursor: not-allowed;
    }
    #defy-chat-send svg {
      width: 16px;
      height: 16px;
      fill: #fff;
    }
    @media (max-width: 420px) {
      #defy-chat-window {
        width: calc(100vw - 24px);
        max-height: 70vh;
        bottom: 80px;
        right: 0;
        border-radius: 12px 12px 0 0;
      }
      #defy-chat-root {
        bottom: 16px;
        right: 16px;
      }
    }
  `;
  document.head.appendChild(style);

  // ── Markdown renderer (minimal, no deps) ───────────────────────────────────
  function renderMarkdown(text) {
    return text
      // Bold
      .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
      // Italic
      .replace(/\*([^*]+)\*/g, "<em>$1</em>")
      // Links
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>')
      // Auto-link URLs
      .replace(/(https?:\/\/[^\s<>"]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>')
      // Bullet list items
      .replace(/^[•\-\*] (.+)$/gm, "<li>$1</li>")
      // Wrap consecutive <li> in <ul>
      .replace(/(<li>.*<\/li>(\n|$))+/g, (match) => `<ul>${match}</ul>`)
      // Line breaks
      .replace(/\n\n/g, "</p><p>")
      .replace(/\n/g, "<br>")
      // Wrap in paragraph
      .replace(/^(.+)$/, "<p>$1</p>");
  }

  // ── API call ───────────────────────────────────────────────────────────────
  async function sendToAPI(msgs) {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        json: {
          messages: msgs.map((m) => ({ role: m.role, content: m.content })),
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    // tRPC response format: { result: { data: { json: { reply: string } } } }
    return data?.result?.data?.json?.reply || data?.result?.data?.reply || "Sorry, I couldn't get a response.";
  }

  // ── DOM helpers ────────────────────────────────────────────────────────────
  function createMessageEl(msg) {
    const wrapper = document.createElement("div");
    wrapper.className = `defy-msg ${msg.role}`;

    const bubble = document.createElement("div");
    bubble.className = "defy-msg-bubble";
    bubble.innerHTML = renderMarkdown(msg.content);

    wrapper.appendChild(bubble);
    return wrapper;
  }

  function createTypingEl() {
    const wrapper = document.createElement("div");
    wrapper.className = "defy-msg assistant";
    wrapper.id = "defy-typing-indicator";

    const typing = document.createElement("div");
    typing.className = "defy-typing";
    for (let i = 0; i < 3; i++) {
      const dot = document.createElement("div");
      dot.className = "defy-typing-dot";
      typing.appendChild(dot);
    }

    wrapper.appendChild(typing);
    return wrapper;
  }

  // ── Render ─────────────────────────────────────────────────────────────────
  const root = document.createElement("div");
  root.id = "defy-chat-root";

  // Chat window (hidden initially)
  let windowEl = null;

  function buildWindow() {
    const win = document.createElement("div");
    win.id = "defy-chat-window";

    // Header
    win.innerHTML = `
      <div id="defy-chat-header">
        <div id="defy-chat-header-avatar">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>
          </svg>
        </div>
        <div id="defy-chat-header-info">
          <div id="defy-chat-header-name">Defy Sports AI</div>
          <div id="defy-chat-header-status">Online</div>
        </div>
        <button id="defy-chat-close" aria-label="Close chat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div id="defy-chat-messages"></div>
      <div id="defy-chat-suggestions"></div>
      <div id="defy-chat-input-row">
        <input id="defy-chat-input" type="text" placeholder="Ask about jerseys, kits, club shops…" autocomplete="off" />
        <button id="defy-chat-send" aria-label="Send">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
          </svg>
        </button>
      </div>
    `;

    return win;
  }

  const SUGGESTIONS = [
    "GAA jerseys",
    "Club shop setup",
    "Personalisation options",
    "Delivery & returns",
    "Soccer kits",
    "Rugby teamwear",
  ];

  function renderSuggestions() {
    const suggestionsEl = document.getElementById("defy-chat-suggestions");
    if (!suggestionsEl) return;
    suggestionsEl.innerHTML = "";
    // Only show suggestions when there's only the welcome message
    if (messages.length <= 1) {
      SUGGESTIONS.forEach((s) => {
        const btn = document.createElement("button");
        btn.className = "defy-suggestion";
        btn.textContent = s;
        btn.addEventListener("click", () => handleSend(s));
        suggestionsEl.appendChild(btn);
      });
    }
  }

  function renderMessages() {
    const msgsEl = document.getElementById("defy-chat-messages");
    if (!msgsEl) return;
    msgsEl.innerHTML = "";
    messages.forEach((m) => {
      msgsEl.appendChild(createMessageEl(m));
    });
    if (isTyping) {
      msgsEl.appendChild(createTypingEl());
    }
    msgsEl.scrollTop = msgsEl.scrollHeight;
    renderSuggestions();
  }

  async function handleSend(text) {
    const trimmed = (text || "").trim();
    if (!trimmed || isTyping) return;

    // Clear input
    const inputEl = document.getElementById("defy-chat-input");
    if (inputEl) inputEl.value = "";

    // Add user message
    messages.push({ role: "user", content: trimmed });
    isTyping = true;
    renderMessages();

    // Disable send button
    const sendBtn = document.getElementById("defy-chat-send");
    if (sendBtn) sendBtn.disabled = true;

    try {
      const reply = await sendToAPI(messages);
      messages.push({ role: "assistant", content: reply });
    } catch (err) {
      messages.push({
        role: "assistant",
        content:
          "Sorry, I ran into an issue connecting to the server. Please try again or contact us at **info@defysports.ie**",
      });
    }

    isTyping = false;
    if (sendBtn) sendBtn.disabled = false;
    renderMessages();

    // Re-focus input
    if (inputEl) inputEl.focus();
  }

  function openChat() {
    if (isOpen) return;
    isOpen = true;

    windowEl = buildWindow();
    root.insertBefore(windowEl, root.firstChild);

    // Bind events
    document.getElementById("defy-chat-close").addEventListener("click", closeChat);

    const inputEl = document.getElementById("defy-chat-input");
    const sendBtn = document.getElementById("defy-chat-send");

    inputEl.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        handleSend(inputEl.value);
      }
    });

    sendBtn.addEventListener("click", () => handleSend(inputEl.value));

    renderMessages();
    setTimeout(() => inputEl.focus(), 100);
  }

  function closeChat() {
    if (!isOpen) return;
    isOpen = false;
    if (windowEl) {
      windowEl.remove();
      windowEl = null;
    }
  }

  // Bubble button
  const bubble = document.createElement("button");
  bubble.id = "defy-chat-bubble";
  bubble.setAttribute("aria-label", "Open Defy Sports chat");
  bubble.innerHTML = `
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
    </svg>
  `;
  bubble.addEventListener("click", () => {
    if (isOpen) {
      closeChat();
    } else {
      openChat();
    }
  });

  root.appendChild(bubble);
  document.body.appendChild(root);
})();
